import React, { useContext, useMemo } from 'react';
import PacketInfoButton from '@ctsu/packet-i-button';
import { AppContext, getToken } from '@ctsu/loader';
import { ATCONSTANTS as ATC } from 'appconstants';
import { RenderElement } from 'components/RenderHelpers';
import { CanUserViewIbutton } from 'appconstants/Permission';

function PacketIButton({
  packetDbId,
  packetId,
  tooltip
}) {
  const { session: { username } } = useContext(AppContext);
  const props = useMemo(() => {
    const data = {
      getToken,
      userName: username,
      dataId: `${ATC.PACKETID}${packetId}${ATC.BUTTON}`,
      packetDbId,
      packetId
    };
    if (tooltip) {
      data.tooltip = tooltip;
    }
    return data;
  }, [packetDbId, packetId, tooltip, username]);

  return packetDbId ? (
    <RenderElement access={CanUserViewIbutton()}>
      <PacketInfoButton {...props} showAagDbInfo />
    </RenderElement>
  ) : null;
}

export default PacketIButton;
